import { render } from "./AnimationText.vue?vue&type=template&id=11fdbb6a"
import script from "./AnimationText.vue?vue&type=script&lang=js"
export * from "./AnimationText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__